import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { FormControlLabel, Switch } from '@mui/material';

import { StyledContainer } from '../styles';
import type { InputSwitchProps } from '../types';

export default function InputSwitch<T extends FieldValues>({
  name,
  control,
  inputProps,
  label,
}: InputSwitchProps<T>) {
  return (
    <StyledContainer>
      <FormControlLabel
        label={label}
        control={
          <Controller
            control={control}
            name={name}
            render={({ field }) => <Switch {...inputProps} {...field} />}
          />
        }
      />
    </StyledContainer>
  );
}
